import { render, staticRenderFns } from "./EbisApfResidencyInputs.vue?vue&type=template&id=2162321a&scoped=true"
import script from "./EbisApfResidencyInputs.vue?vue&type=script&lang=js"
export * from "./EbisApfResidencyInputs.vue?vue&type=script&lang=js"
import style0 from "./EbisApfResidencyInputs.vue?vue&type=style&index=0&id=2162321a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2162321a",
  null
  
)

export default component.exports